import React, { Component} from 'react';
import { BrowserRouter as Router, Route,Switch} from "react-router-dom";
import  ENG  from './ENG';
import  ESP  from './ESP';
import  CHN  from './CHN';
import  ARB  from './ARB';
import  RUS  from './RUS';
import  FRE  from './FRE';

function App() {
  return (
    <React.Fragment>
        <Router>
          <Switch>
            <Route exact path="/" component={ENG} />
            <Route path="/ENG" component={ENG} />
            <Route path="/ESP" component={ESP} />
            <Route path="/CHN" component={CHN} />
            <Route path="/ARB" component={ARB} />
            <Route path="/FRE" component={FRE} />
            <Route path="/RUS" component={RUS} />
          </Switch>
        </Router>
      </React.Fragment>

    
  );
}

export default App;
